import React from 'react'
import { SequenceAnimator } from 'react-sequence-animator';
import Cat1 from "./darkLogoImges/LB LOGO WHITE00.png"
import Cat2 from "./darkLogoImges/LB LOGO WHITE01.png"
import Cat3 from "./darkLogoImges/LB LOGO WHITE02.png"
import Cat4 from "./darkLogoImges/LB LOGO WHITE03.png"
import Cat5 from "./darkLogoImges/LB LOGO WHITE04.png"
import Cat6 from "./darkLogoImges/LB LOGO WHITE05.png"
import Cat7 from "./darkLogoImges/LB LOGO WHITE06.png"
import Cat8 from "./darkLogoImges/LB LOGO WHITE07.png"
import Cat9 from "./darkLogoImges/LB LOGO WHITE08.png"
import Cat10 from "./darkLogoImges/LB LOGO WHITE09.png"
import Cat11 from "./darkLogoImges/LB LOGO WHITE10.png"
import Cat12 from "./darkLogoImges/LB LOGO WHITE11.png"
import Cat13 from "./darkLogoImges/LB LOGO WHITE12.png"
import Cat14 from "./darkLogoImges/LB LOGO WHITE13.png"
import Cat15 from "./darkLogoImges/LB LOGO WHITE14.png"
import Cat16 from "./darkLogoImges/LB LOGO WHITE15.png"
import Cat17 from "./darkLogoImges/LB LOGO WHITE16.png"
import Cat18 from "./darkLogoImges/LB LOGO WHITE17.png"
import Cat19 from "./darkLogoImges/LB LOGO WHITE18.png"
import Cat20 from "./darkLogoImges/LB LOGO WHITE19.png"
import Cat21 from "./darkLogoImges/LB LOGO WHITE20.png"
import Cat22 from "./darkLogoImges/LB LOGO WHITE21.png"
import Cat23 from "./darkLogoImges/LB LOGO WHITE22.png"
import Cat24 from "./darkLogoImges/LB LOGO WHITE23.png"
import Cat25 from "./darkLogoImges/LB LOGO WHITE24.png"
import Cat26 from "./darkLogoImges/LB LOGO WHITE25.png"
import Cat27 from "./darkLogoImges/LB LOGO WHITE26.png"
import Cat28 from "./darkLogoImges/LB LOGO WHITE27.png"
import Cat29 from "./darkLogoImges/LB LOGO WHITE28.png"
import Cat30 from "./darkLogoImges/LB LOGO WHITE29.png"
import Cat31 from "./darkLogoImges/LB LOGO WHITE30.png"
import Cat32 from "./darkLogoImges/LB LOGO WHITE31.png"
import Cat33 from "./darkLogoImges/LB LOGO WHITE32.png"
import Cat34 from "./darkLogoImges/LB LOGO WHITE33.png"
import Cat35 from "./darkLogoImges/LB LOGO WHITE34.png"

const LogoDarkAnimator = () => {
    return (
        <SequenceAnimator autoplay loop={false}  >
            <img src={Cat1} alt="cat1" width="210px" />
            <img src={Cat2} alt="cat1" width="210px" />
            <img src={Cat3} alt="cat1" width="210px" />
            <img src={Cat4} alt="cat1" width="210px" />
            <img src={Cat5} alt="cat1" width="210px" />
            <img src={Cat6} alt="cat1" width="210px" />
            <img src={Cat7} alt="cat1" width="210px" />
            <img src={Cat8} alt="cat1" width="210px" />
            <img src={Cat9} alt="cat1" width="210px" />
            <img src={Cat10} alt="cat1" width="210px" />
            <img src={Cat11} alt="cat1" width="210px" />
            <img src={Cat12} alt="cat1" width="210px" />
            <img src={Cat13} alt="cat1" width="210px" />
            <img src={Cat14} alt="cat1" width="210px" />
            <img src={Cat15} alt="cat1" width="210px" />
            <img src={Cat16} alt="cat1" width="210px" />
            <img src={Cat17} alt="cat1" width="210px" />
            <img src={Cat18} alt="cat1" width="210px" />
            <img src={Cat19} alt="cat1" width="210px" />
            <img src={Cat20} alt="cat1" width="210px" />
            <img src={Cat21} alt="cat1" width="210px" />
            <img src={Cat22} alt="cat1" width="210px" />
            <img src={Cat23} alt="cat1" width="210px" />
            <img src={Cat24} alt="cat1" width="210px" />
            <img src={Cat25} alt="cat1" width="210px" />
            <img src={Cat26} alt="cat1" width="210px" />
            <img src={Cat27} alt="cat1" width="210px" />
            <img src={Cat28} alt="cat1" width="210px" />
            <img src={Cat29} alt="cat1" width="210px" />
            <img src={Cat30} alt="cat1" width="210px" />
            <img src={Cat31} alt="cat1" width="210px" />
            <img src={Cat32} alt="cat1" width="210px" />
            <img src={Cat33} alt="cat1" width="210px" />
            <img src={Cat34} alt="cat1" width="210px" />
            <img src={Cat35} alt="cat1" width="210px" />
        </SequenceAnimator>
    )
}

export default LogoDarkAnimator